import { userConstants } from '../constants';

const initialState = { tableData: [] }

export function searchData(state = initialState, action) {
  console.log('state',initialState,'action',action);
  switch (action.type) {
    case userConstants.UPDATE_TABLE_DATA:
      return {
        tableData: action.data
      }
    case userConstants.RESET_TABLE_DATA:
      return {
        tableData: null
      }
    case userConstants.SET_BLOCKING_STATE:
      return { blocking: action.payload }
      case userConstants.SET_DELETE_STATE:
       return {deleteStatus:action.payload}
       case userConstants.SET_CREATE_STATE:
       return {createStatus:action.payload}
    case userConstants.UPDATE_AUDITOR_DATA:
    return {auditorUser:action.data}
   default:
      return state
  }
}